import styled from "styled-components"
import {RouterLink as RouterLinkBase} from "@irati/ui/src/Link"
import {Lato} from "@irati/ui/src/global/fonts"

const RouterLink = styled(RouterLinkBase)`
  ${Lato}
  text-align: left;
  cursor: pointer;
  text-transform: none;
  text-decoration: none;
  color: inherit;

  &:hover,
  &:focus {
    text-decoration: none;
  }
`

export default RouterLink
